<ng-container *ngIf="!imageSrc; else imgview "></ng-container>

<div class="container" [class.hidden]="imageSrc" *ngIf="!imageSrc">
  <div class="button-group" [class.care-conne]="isCareConneFeat">
  <!-- <div class="button-group"> -->
    <button *ngIf="writable" mat-button type="button" class="delete-button" [disabled]="disabled" (click)="delete()">
      <mat-icon svgIcon="delete"></mat-icon> 削除
    </button>
    <button [routerLink]="editLink('duplicate')" [queryParamsHandling]="'preserve'" mat-button type="button"
      class="duplicate-button">
      <mat-icon svgIcon="duplicate"></mat-icon> 複製
    </button>
    <button *ngIf="writable" [routerLink]="editLink()" [queryParamsHandling]="'preserve'" [disabled]="disabled"
      mat-button type="button" class="edit-button">
      <mat-icon svgIcon="edit"></mat-icon> 編集
    </button>
    <button mat-button type="button" class="button-careconne" [class.disabled]="!isCareConneFeat" (click)="sendToCareConne()">
      ケアコネ
    </button>
  </div>
  <div class="display-group" *ngIf="noteParam">
    <div class="record-item" [class.pickup]="pickup">
      <dt class="header koru">
        <span class="title no-font-scale">
          <span *ngIf="record.sdate && record.edate" class="time">
            {{ record.sdate | date: "HH:mm" }}
          </span>
          <span class="name">{{ record.ttlnm }}</span>
        </span>
      </dt>
      <dd #container>
        <ng-container *ngIf="noteParam">
          <lib-note-detail [params]="noteParam" #libEl></lib-note-detail>
        </ng-container>
      </dd>


    </div>

  </div>
</div>

<ng-template #imgview>
  <div class="imgView">
    <div class="background" (click)="unbindImg()">
    </div>
    <img [src]="imageSrc" />
  </div>

</ng-template>